<script setup>
import {computed} from 'vue'
import moment from 'moment'
import FormControlPlainText from "@/common/form-control/FormControlPlainText.vue"

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: [String, Number]
})

const timestamp = computed(() => props.currentData?.[props.field.name])
const dateString = computed(() => timestamp.value ? moment(timestamp.value * 1000).format('DD MMM YYYY, HH:mm') : null)
</script>

<template>
    <FormControlPlainText v-if="dateString" :value="dateString" :form-id="formId"/>
    <FormControlPlainText v-else :form-id="formId">
        <i class="small text-dark-emphasis">unset</i>
    </FormControlPlainText>
</template>